import { Track } from './track'
import { installTrack } from './directive'
const initConfig = {
  env: 'dev',
  appCode: null,
  collectionUrl: null
}

export default class NsTrack {
  constructor () {
    this.installed = false
  }

  static install (app, options = initConfig) {
    const { userInfo, appCode } = options
    // app.config.errorHandler = (error, instance, info) => {
    //   console.error('Error:', error)
    //   console.error('Component:', instance)
    //   console.error('Info:', info)
    // }
    if (!appCode) {
      console.warn('🐛 没有注册应用,请填写appCode')
      return
    }
    if (!userInfo) {
      console.warn('🐛 系统未登录')
      return
    }

    if (this.installed) return
    const track = new Track(options)
    this.installed = true

    installTrack(app)
    console.log('😊 track sdk installed')

    app.component('NsTrack', {
      render: (h) =>
        h('span', {
          style: 'display: none'
        })
    })

    app.prototype.$track = track
    app.mixin({
      data: () => ({
        PAGE_ENTER_TIME: Date.now()
      }),
      // beforeRouteEnter (_, __, next) {
      //   next((vm) => {
      //     console.log('beforeRouteEnter==', vm)
      //   })
      // },
      // beforeRouteUpdate (_, __, next) {
      // this.$watch('$route', () => {
      // })
      //   next()
      // },
      beforeRouteLeave (_, __, next) {
        track.sendTrack(
          'PAGE_VIEW',
          track.pageViewLog({ enterTime: this.PAGE_ENTER_TIME })
        )
        next()
      }
    })
  }
}
